import {
  SalesRegionData,
  SalesRegions,
} from "@endavaaccorplus/payments-common";

export const getSubsidiaryAttribute = (
  salesRegion: (typeof SalesRegions)[number],
) => {
  const salesRegionObject = Object.entries(SalesRegionData).find(
    ([key, _]) => key === salesRegion,
  );
  return salesRegionObject ? salesRegionObject[1].subsidiary : "";
};
